import React from 'react'
import { FloatingFilter } from '../../../components'
import { Featured } from './featured'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import PaginatedList from './paginated-list'

const MainContentMobile = ({
  resources,
  embed,
  pageConfig,
  actions,
  stateKey = 'resources',
}) => {
  const query = qs.parse(useLocation().search)

  return (
    <div className={`${embed ? '' : 'pt-5'}`}>
      {
        Object.keys(query).length === 0 &&
        <Featured embed={embed}/>
      }
      <section className="container mx-auto">
        <PaginatedList
          query={query}
          defaultData={resources}
          stateKey={stateKey}
          pageConfig={pageConfig}
          actions={actions}
        />
      </section>
      <FloatingFilter filterOptions={{
        keyword: false,
        location: false,
        type: true,
        date: true,
        category_resource: true,
        type_resource: true
      }}/>
    </div>
  )
}

export { MainContentMobile }
